/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureBalanceIntegrationViewModel {
  visitId?: string;
  /**
   * Procedure Code
   */
  procedureCode?: string | null;
  /**
   * Attending Provider
   */
  attendingProvider?: string | null;
  /**
   * Procedure Date
   */
  procedureDate?: string;
  /**
   * Procedure Charge Amount
   */
  procedureAmount?: number;
  /**
   * Total Payments
   */
  paidAmount?: number;
  /**
   * Total Adjustments
   */
  adjustmentAmount?: number;
  /**
   * Procedure balance
   */
  balance?: number;
}
